import PlayerBasicsStep from "./PlayerBasicsStep";
import JgsLinkStep from "./JgsLinkStep";
import DreamSchoolsStep from "./DreamSchoolsStep";
import AcademicsStep from "./AcademicsStep";
import PreferencesStep from "./PreferencesStep";
import RecruitingProgressStep from "./RecruitingProgressStep";
import RoleStep from "./RoleStep";
import { isProfileLinked } from "./types";
import type { OnboardingStep } from "./types";

/**
 * Ordered registry of onboarding steps. The wizard is answer-driven and derives
 * resume and completion purely from each step's `isComplete(profile)`.
 *
 * Note: the dream-schools and recruiting-progress steps have no persisted
 * marker (their data goes to the plan-generation call, not the profile), so
 * their `isComplete` is always false — a returning user resumes at the dream
 * step at the latest. Acceptable: both steps are optional and fast to pass.
 */
export const ONBOARDING_STEPS: OnboardingStep[] = [
  {
    id: "role",
    title: "Your role",
    Component: RoleStep,
    isComplete: profile => profile.onboardingRole != null,
  },
  {
    id: "player-basics",
    title: "Player basics",
    Component: PlayerBasicsStep,
    isComplete: profile =>
      !!profile.displayName && !!profile.gradYear && !!profile.state && !!profile.gender,
  },
  {
    id: "jgs-link",
    title: "Junior golf ranking",
    Component: JgsLinkStep,
    // Linked counts as complete on mount; skipping/answering completes it at runtime.
    isComplete: profile => isProfileLinked(profile),
    canSkip: true,
    managesOwnNavigation: true,
  },
  {
    id: "dream-schools",
    title: "Dream schools",
    Component: DreamSchoolsStep,
    isComplete: () => false,
    canSkip: true,
  },
  {
    id: "academics",
    title: "Academics",
    Component: AcademicsStep,
    isComplete: profile => profile.weightedGpa != null || !!profile.preferredMajors?.length,
    canSkip: true,
  },
  {
    id: "preferences",
    title: "Preferences",
    Component: PreferencesStep,
    isComplete: profile =>
      Array.isArray(profile.divisionsOpenTo) && profile.divisionsOpenTo.length > 0,
    canSkip: true,
  },
  {
    id: "recruiting-progress",
    title: "Recruiting progress",
    Component: RecruitingProgressStep,
    isComplete: () => false,
    canSkip: true,
    continueLabel: "Build my plan",
  },
];
